"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/DateWeek.js";
var options = [{
  label: 'This Week',
  value: 7
}, {
  label: 'Last Week',
  value: 14
}, {
  label: 'Last Two Week',
  value: 21
}, {
  label: 'Last Three Week',
  value: 28
}];
function DateWeek(_ref) {
  var _this = this;
  var field = _ref.field,
    onChange = _ref.onChange;
  function _onChange(value) {
    var where = {};
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - value);
    startDate.setHours(0, 0, 0, 0);
    var endDate = new Date();
    endDate.setDate(startDate.getDate() + 7);
    endDate.setHours(23, 59, 59, 999);
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString()
    };
    onChange(where);
  }
  _react["default"].useEffect(function () {
    _onChange(options[0].value);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("select", {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    className: "form-select shadow-none fs-xs w-auto rounded-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }, options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: o.value,
      value: o.value,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 29
      }
    }, o.label);
  }));
}
var _default = DateWeek;
exports["default"] = _default;